export const getInitials = (from: string, { separator = ' ' } = {}): string => {
  return from
    .split(separator)
    .map((partOfFrom) => partOfFrom.slice(0, 1))
    .join(' ')
}
